export function cleanUpContainer(containerId) {
    const myNode = document.getElementById(containerId);
    myNode.innerHTML = "";
}

 